import type { FilesFormatSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';
import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { mediaTypeIcon } from '@iconik-io/shared-lib/src/utils/media_icon_type';
import type { IconName } from '@iconik-io/uad';

import { getFormatMediaType, getSearchItemMediaType } from './media_type';

export const getSearchItemIconType = (
  searchItem: SearchItemEntity,
): IconName | undefined => {
  const mediaType = getSearchItemMediaType(searchItem);
  if (!mediaType) {
    return undefined;
  }
  return mediaTypeIcon[mediaType];
};

export const getFormatIconType = (
  format: FilesFormatSchemaWithIdNullable | undefined,
): IconName | undefined => {
  const mediaType = getFormatMediaType(format);
  if (!mediaType) {
    return undefined;
  }
  return mediaTypeIcon[mediaType];
};
